(function ($) {
    "use strict";
    $(function () {    
        if ($('.js-question-answer-form').length === 0) {
            return;
        }

        $(document).on("click", ".js-submit-question", function (e) {
            e.preventDefault();

            var form = $('.js-question-answer-form');
            var data = grabFormAsObject(form);

            if ($('#subject').val().trim() == '') {
                alert('Kérjük röviden foglalja össze a panaszát!');
                return false;
            }

            if ($('#problem').val().length < 25) {
                alert('Kérjük kicsit részletesebben írja problémáját.');
                return false;
            }

            if (!$('#terms').is(':checked')) {
                alert('Kérjük fogadja el az adatkezelési tájékoztatót!');
                return false;
            }

            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: {
                    action: "submit_question_answer",
                    data: data
                },
                success: function (response) {
                    form.trigger("reset");
                    $('.js-hide-for-success').addClass('d-none');
                    $('.js-qa-success').removeClass('d-none');
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                }
            });
        });
    });
})(jQuery);